import { render, staticRenderFns } from "./ClosingOrder.vue?vue&type=template&id=a874e7b8&scoped=true&"
import script from "./ClosingOrder.vue?vue&type=script&lang=js&"
export * from "./ClosingOrder.vue?vue&type=script&lang=js&"
import style0 from "./ClosingOrder.vue?vue&type=style&index=0&id=a874e7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a874e7b8",
  null
  
)

export default component.exports